import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import * as React from 'react';

import { ExternalLinkIcon } from '@/imports/ui/chakra/feather';

export const ExternalRegistrationModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  externalRegistrationUrl: string;
}> = ({ isOpen, onClose, externalRegistrationUrl }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Registration Details</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            Registration for this event is hosted on an external platform. You
            may experience a delay before your registration status is reflected
            within Tradewing.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" colorScheme="gray" onClick={onClose} mr="2">
            Close
          </Button>

          <Button
            as="a"
            target="_blank"
            rel="noreferrer"
            href={externalRegistrationUrl}
            rightIcon={<ExternalLinkIcon />}
          >
            Register on External Platform
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
